import styled from "styled-components";

export const FestivalMainRankWrapper = styled.div`
  width: 100%;
  padding: 0 16px;
`;

export const FestivalMainRankContent = styled.div`
  width: 100%;
  background: #f0f0f0;
  border-radius: 8px;
  padding-bottom: 30px;
`;

export const FestivalMainRankListWrapper = styled.div`
  min-height: 296px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  margin-top: 32px;
`;
